import type { SxProps, Theme } from "@mui/material/styles";
export const stack: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: { xs: 1.75, md: 2.25 } };
export const grid: SxProps<Theme> = { display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 1.75 };
